import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {IDestinationBox} from '../../interfaces/idestination-box';
import {IDestinationBoxElement} from '../../interfaces/idestination-box-element';

@Component({
  selector: 'app-holiday-destinations-list',
  templateUrl: './holiday-destinations-list.component.html',
  styleUrls: ['./holiday-destinations-list.component.scss']
})
export class HolidayDestinationsListComponent implements OnInit {

  @Input() destinationBox$: Observable<IDestinationBox[]>;
  @Output() selectedDestination = new EventEmitter<IDestinationBoxElement>();
  selectedGroup: IDestinationBox;
  selectedDestinationInner: IDestinationBoxElement;


  constructor() { }

  ngOnInit(): void {
  }

  selectDestination(destination: IDestinationBoxElement): void {
    this.selectedDestinationInner = destination;
    this.selectedDestination.emit(destination);
  }

  selectGroup(group: IDestinationBox): void {
    this.selectedGroup = group;
  }

  deselectGroup(): void {
    this.selectedGroup = undefined;
  }

}
